import PropTypes from 'prop-types';
import { createContext, useReducer } from 'react';
// hooks

const initialState = {
    ticket: {},
    url: "",
    onChangeTicket: () => {},
};

const handlers = {
    SETTICKET: (state, action) => {
        const { ticket, url } = action.payload;
        return {
            ...state,
            ticket,
            url
        }
    }
}

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const TicketContext = createContext(initialState);

TicketProvider.propTypes = {
    children: PropTypes.node,
};

function TicketProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState);

    const onChangeTicket = (ticket, url) => {
        dispatch({
            type: 'SETTICKET',
            payload: {
                ticket,
                url
            }
        });
    }

    return (
        <TicketContext.Provider
            value={{
                ...state,
                onChangeTicket,
            }}
        >
            {children}
        </TicketContext.Provider>
    );
}

export { TicketProvider, TicketContext };
